import { useCallback } from "react";

import { useUserTriggeredModalsHistoryState } from "../history/use-modal-history-states";
import type { ModalComponent } from "../modal-builder";
import { type ModalWithOptionalDeduplicationKey, resolveModalId } from "../modal-id";
import { useUserTriggeredModalsStore } from "../user-triggered-modals.store";

export const useModalOpenOperations = () => {
  const [, , pushTemporaryModalsState] = useUserTriggeredModalsHistoryState();

  const peekOpenIds = useUserTriggeredModalsStore((state) => state.peekOpenIds);
  const setArgs = useUserTriggeredModalsStore((state) => state.setArgs);

  const openUserTriggeredModal = useCallback(
    <Args>(modal: ModalWithOptionalDeduplicationKey<ModalComponent<never>>, args?: Args) => {
      const openModalIds = peekOpenIds();

      const id = resolveModalId(modal);
      if (openModalIds.includes(id)) {
        return;
      }

      setArgs(id, args);
      pushTemporaryModalsState((temporaryModalsState) => [...temporaryModalsState, { id, args, state: null }]);
    },
    [peekOpenIds, pushTemporaryModalsState, setArgs],
  );

  return { openUserTriggeredModal };
};
